module.exports = __webpack_public_path__ + "img/auction-4.f883d060.png";